// extracted by mini-css-extract-plugin
export default {"alert_danger":"AlertDanger_alert_danger__hriNw"};